import axios from '@/utils/request'

export function fetchQiniuToken() {
    return axios.get('/v4/upload/token?bucket=media')
}
/**
 * 首页banner统计
 * @param {*} data 
 */
export function fetchHomeStat(data) {
    return axios.get('/v4/home/stat', { params: data })
}

/**
 * 首页已发布列表
 * @param {*} data 
 */
export function fetchPublished(data) {
    return axios.get('/v4/projects/published', { params: data })
}

/**
 * 首页草稿列表
 * @param {*} data 
 */
export function fetchDraft(data) {
    return axios.get('/v4/projects/draft', { params: data })
}

/**
 * 【发布】案例或草稿
 * @param {
 *  projectId : Number
 *  draftId : Number
 * }  
 */
export function fetchPublish(data) {
    return axios.post('/v4/projects/publish', data)
}

/**
 * 【保存草稿】创建草稿，编辑草稿-自动保存
 * @param {
 *  projectId : Number
 *  draftId : Number
 * }  
 */
export function fetchSaveDraft(data) {
    return axios.post('/v4/draft', data)
}

/**
 * 获取全屋案例草稿数据
 * @param {*} draftId 
 */
export function fetchHouseDraftData(draftId) {
    return axios.get(`/v4/project/house/draft/${draftId}`)
}

/**
 * 获取自定义案例草稿数据
 * @param {*} draftId 
 */
export function fetchCustomDraftEditData(draftId) {
    return axios.get(`/v4/project/custom/draft/${draftId}`)
}

/**
 * 获取已发布的全屋案例数据,生成新草稿
 * @param {*} projectId 
 */
export function fetchHouseEditData(projectId) {
    return axios.get(`/v4/project/house/edit/${projectId}`)
}

/**
 * 获取已发布的自定义案例数据,生成新草稿
 * @param {*} projectId 
 */
export function fetchCustomEditData(projectId) {
    return axios.get(`/v4/project/custom/edit/${projectId}`)
}

/**
 * 删除案例
 * @param {*} projectId 
 */
export function fetchDeleteProject(projectId) {
    return axios.delete(`/v4/projects/${projectId}`)
}

/**
 * 删除草稿
 * @param {*} draftId 
 */
export function fetchDeleteDraft(draftId) {
    return axios.delete(`/v4/drafts/${draftId}`)
}

/**
 * 转发到设交
 * @param {*} data 
 */
export function fetchShareSocial(data) {
    return axios.post(`/v4/social/feeds`, data)
}


/**
 * 修改发布平台
 * @param {*} data 
 */
export function fetchUpdatePlatform(data) {
    return axios.put(`/py.project.edit/1.2.0/platform`, data)
}


